/**
 * Formate une durée en minutes en chaîne lisible (ex: "1 h 30 m" ou "1h30m").
 *
 * @param {number|string} minutes - Durée en minutes
 * @param {Object} [options]
 * @param {string} [options.fallback='-'] - Valeur renvoyée si minutes est vide / 0
 * @param {boolean} [options.spaced=true] - Ajoute des espaces dans l'unité (ex: "1 h 30 m" vs "1h30m")
 * @returns {string}
 */
export function formatTime(minutes, { fallback = '-', spaced = true } = {}) {
  const numMinutes = Number(minutes)
  if (!numMinutes || isNaN(numMinutes)) {
    return fallback
  }

  const hours = Math.floor(numMinutes / 60)
  const mins = numMinutes % 60
  const unitSpace = spaced ? ' ' : ''

  let result = ''
  if (hours > 0) {
    result += `${hours}${unitSpace}h`
  }

  if (mins > 0) {
    const formattedMins = mins < 10 ? `0${mins}` : `${mins}`
    const separator = result ? (spaced ? ' ' : '') : ''
    result += `${separator}${formattedMins}${unitSpace}m`
  }

  return result.trim() || fallback
}

